import React from 'react'

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";

import { withStyles,
TextField, Button } from "@material-ui/core";

import { withFormik } from "formik";
import * as Yup from "yup";


const styles= ()=>({
    card:{
        maxWidth: 420,
    },
    container: {
        display: 'flex',
        justifyContet: 'center'
    },
    actions: {
        float: 'right',
        padding: '0px 16px 8px 8px'
    },
})


const StakeUpdateForm_=(props)=>{

    const {
        classes,
        values,
        touched,
        errors,
        isSubmitting,
        handleChange,
        handleBlur,
        handleSubmit,
        handleReset,
        customer,
        submithandlerProp
      } = props;


    return(
        <div className={classes.container}>

            <form onSubmit={handleSubmit}>
                <Card className={classes.card}>            

                    <CardContent>
                  
                        <TextField
                        id='holderName'
                        label="Holder Name"
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        value={values.holderName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={touched.holderName? errors.holderName : ""}
                        error={touched.holderName && Boolean(errors.holderName)}
                        />


                        <TextField 
                        id="email"
                        label="Email"
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        type="email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={touched.email? errors.email : ""}
                        error={touched.email && Boolean(errors.email)}
                        />

                        <TextField
                        id="numberOfShares"
                        label="Number Of Shares"
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        value={values.numberOfShares}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={touched.numberOfShares? errors.numberOfShares : ""}
                        error={touched.numberOfShares && Boolean(errors.numberOfShares)}
                        />

                        <TextField
                        id="valueOfInvestment"
                        label="Value Of Investment"
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        value={values.valueOfInvestment}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={touched.valueOfInvestment? errors.valueOfInvestment : ""}
                        error={touched.valueOfInvestment && Boolean(errors.valueOfInvestment)}
                        />

                    </CardContent>
                    <CardActions className={classes.actions}>
                        <Button color="primary" type="submit" variant="outlined" 
                        disabled={isSubmitting}
                        >Update</Button>
                    </CardActions>
                </Card>
            </form>
        </div>
    )
}


const StakeUpdateForm= withFormik({
    mapPropsToValues: (props
    //     {
    //     invoice,
    //     customerName,
    //     email,
    //     profit,
    //     status,
    //     customer,
    //     submithandlerProp
    // }
    )=>{
        const {holder , ...rest}=props
        return {
            holderName: holder.holderName || "",
            email: holder.email || "",
            numberOfShares: holder.numberOfShares || "",
            valueOfInvestment: holder.valueOfInvestment || "",
        }
    },
    validationSchema: Yup.object().shape({
        
        holderName: Yup.string().required("Required"),
        email: Yup.string()
        .email("Enter a valid email")
        .required("Email is required"),
        numberOfShares: Yup.string()
        .required("Required"),
        valueOfInvestment: Yup.string()
        .required("Required"),
        
    }),
    // handleSubmit: (values, { setSubmitting }) =>{
    //     console.log(rest)
    //     //console.log(submithandlerProp())
    //     setTimeout(()=>{
    //         //submtting
    //         //this.submithandlerProp()
    //         // submithandlerProp()
    //         alert(JSON.stringify(values, null,2))
    //         setSubmitting(false)
    //     }, 1000)
    // }
    handleSubmit: (values, formikBag) =>{
        console.log(formikBag.props)
        const {props,setSubmitting} =formikBag
        setTimeout(()=>{
            //alert(JSON.stringify(values, null,2))
            setSubmitting(false)
            props.submithandlerProp(values)
        },500)
       
    }
}
)(StakeUpdateForm_)


export default  withStyles(styles)(StakeUpdateForm) 